<script>
import CampaignApi from "@/services/campaign-api";
import LoungeZoneComponent from "@/router/views/menu/order/zone/LoungeZoneComponent.vue";

export default {
    components: {LoungeZoneComponent},
    props : {
      campaign:{
        type:Object,
        default:() => null,
      },
      menu:{
        type:Object,
        default:() => null,
      },
    },

  computed: {
        isSupplier() {
      return this.$cookies.get('userr') == 1;
    },
  },

  data() {
    return {

      orderMenuCampaign: this.campaign ? { ...this.campaign } : {},
      qrStart: null,
      qrEnd: null,
      refreshMapKey: 0,
  

    };
  },
  mounted() {
  
  },

  watch:{
  
  },

  methods: {

    setCurrentLocation(){
      this.orderMenuCampaign.orderMenuLongitude = null,
      this.orderMenuCampaign.orderMenuLatitude = null,
      this.refreshMapKey += 1
    },


    saveMenuOrderSettingsCampain(){      

        const settingsCampaign = {
            id : this.orderMenuCampaign.id,
            orderMenuIsRequiredGps : this.orderMenuCampaign.orderMenuIsRequiredGps,
            orderMenuCallWaiterIsActive : this.orderMenuCampaign.orderMenuCallWaiterIsActive,
            orderMenuLatitude : this.orderMenuCampaign.orderMenuLatitude,
            orderMenuLongitude : this.orderMenuCampaign.orderMenuLongitude,
            orderMenuRadius : this.orderMenuCampaign.orderMenuRadius,
            orderMenuTablesCount : this.orderMenuCampaign.orderMenuTablesCount,

        }

        CampaignApi.saveMenuOrderSettingsCampain(settingsCampaign).then(result =>{
            if(result){
                this.orderMenuCampaign = result,
                this.refreshMapKey += 1

            }
        })
    },

    updatePosition(position) {
      if(position == null){
          return
      }
      this.orderMenuCampaign.orderMenuLatitude = position.latitude
      this.orderMenuCampaign.orderMenuLongitude = position.longitude
    },


    getVirtualQrTable() {
        const menuId = this.menu.id;
        const url = `/qrtables?menuId=${menuId}&start=-1&end=`;
        window.open(url, '_blank');
      },

    getQrTables() {
        const menuId = this.menu.id;
        const start = this.qrStart;
        const end = this.qrEnd;

        if (!menuId || !start || !end || start > end) {

          return;
        }

        const url = `/qrtables?menuId=${menuId}&start=${start}&end=${end}`;

        window.open(url, '_blank');
      },


  },
};
</script>

<template>     
       
  <div class="card">
    <div class="card-body">

      <div class="row">
        <div class="col-md-8 col-12">
          <h2 class="card-title text-uppercase text-dark" style="font-size:25px;">
            {{$t('menuOrder.title') }}
          </h2>
        </div>

        <div class="col-md-4 col-12 mt-md-0 mt-2 text-right">
            <b-button variant="primary" @click="saveMenuOrderSettingsCampain()" class="float-sm-right mt-2 mt-lg-0 mt-xl-0 mt-md-0 font-weight-bold text-uppercase">
                {{$t("buttons.save")}}
            </b-button>
        </div>
      </div>

      <div class="col-12 mt-4">
        <b-form  @submit.prevent="getQrTables"  class="row align-items-center justify-content-center justify-content-sm-end mb-md-0 mb-4" >
          <div class="col-12 col-sm-auto d-flex flex-wrap justify-content-end ">
            <div class="d-flex align-items-center mb-2 mb-sm-0 mr-sm-3">
              <strong class="mr-2" style="white-space: nowrap;">Tables de</strong>
              <b-form-input
                v-model.number="qrStart"
                type="number"
                min="1"
                placeholder="N°"
                maxlength="3"
                class="text-center"
                style="max-width: 80px;"
                required
              />
            </div>

            <div class="d-flex align-items-center mb-2 mb-sm-0">
              <strong class="mx-2">à</strong>
              <b-form-input
                v-model.number="qrEnd"
                type="number"
                min="1"
                placeholder="N°"
                maxlength="3"
                class="text-center"
                style="max-width: 80px;"
                required
              />
            </div>
          </div>

          <div class="col-12 col-sm-auto">
            <div class="col-12 col-sm-auto text-center text-sm-right">
              <div class="ml-3">
                <b-button
                  variant="primary"
                  type="submit"
                  class="font-weight-bold text-uppercase w-100 w-sm-auto "
                  style="height: 36px;"
                >
                {{$t('menuOrder.generateQrCode') }}
                </b-button>
              </div>
            </div>

          </div>

          <div class="col-12 col-sm-auto mt-2 mt-md-0">
            <div class="col-12 col-sm-auto text-center text-sm-right">
              <div class="ml-3">
                <b-button
                @click="getVirtualQrTable"
                  variant="primary"
                  class="font-weight-bold text-uppercase w-100 w-sm-auto "
                  style="height: 36px;"
                >
                {{$t('menuOrder.generateVirtualQrCode') }}
                </b-button>
              </div>
            </div>
          </div>

        </b-form>
      </div>

      <div class="d-flex align-items-center col-12 mb-3" >
        <span for="tables-count-input" class="mr-2 mb-0 font-weight-bold font-size-14 text-dark">
          {{ $t('menuOrder.label.tablesCount') }}
        </span>

        <b-form-input
          id="tables-count-input"
          v-model.number="orderMenuCampaign.orderMenuTablesCount"
          type="number"
          min="1"
          max="999"
          :placeholder="$t('menuOrder.input.tablesCount') "
          class="text-center text-dark font-weight-bold "
          style="max-width: 100px;"
          required
        />
      </div>

      <b-form-group class="mt-3">
        <b-form-checkbox v-model="orderMenuCampaign.orderMenuIsRequiredGps" switch class="float-md-left" :disabled="orderMenuCampaign.id == null"
            :value="true">
            <label class="font-weight-bold font-size-14" :class="orderMenuCampaign.orderMenuIsRequiredGps ? 'text-primary' : 'text-muted'">{{$t('menuOrder.requiredGps') }}</label>
        </b-form-checkbox>
      </b-form-group>

      <b-form-group class="m-0">
        <b-form-checkbox v-model="orderMenuCampaign.orderMenuCallWaiterIsActive" switch class="float-md-left" :disabled="orderMenuCampaign.id == null"
            :value="true">
            <label class="font-weight-bold font-size-14" :class="orderMenuCampaign.orderMenuCallWaiterIsActive ? 'text-primary' : 'text-muted'">{{$t('menuOrder.callServer') }}</label>
        </b-form-checkbox>
      </b-form-group>

      <div
        class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-4"
        :class="{ 'opacity-50 pointer-events-none': !orderMenuCampaign.orderMenuIsRequiredGps }"
      >
        <div class="row mb-1">
          <div class="col-md-6 col-12">
            <div class="font-size-16 pt-2 pb-2 font-weight-bold text-dark">
              {{ $t('ourPartner.selectePosition') }}<span class="text-danger">*</span>
            </div>
          </div>

          <div class="col-md-2 col-12 mb-md-0 mb-2">
            <b-button
              variant="primary"
              type="submit"
              class="font-weight-bold text-uppercase float-right "
              style="height: 36px;"
              @click="setCurrentLocation()"
            >
            {{$t('menuOrder.currentLocation') }}
            </b-button>
          </div>


          <div class="col-md-4 col-12 d-flex justify-content-between">
            <b-form-input
              class="bg-light mr-2  ml-md-2 ml-0" 
              :placeholder="$t('menuOrder.input.latitude')"
              v-model="orderMenuCampaign.orderMenuLatitude"
              :disabled="true"
            />
            <b-form-input
              class="bg-light mr-2"
              :placeholder="$t('menuOrder.input.longitude')"
              v-model="orderMenuCampaign.orderMenuLongitude"
              :disabled="true"
            />
            
            <b-form-input
              :placeholder="$t('menuOrder.input.radius')"
              v-model.number="orderMenuCampaign.orderMenuRadius"
              type="number"
              min="20"
              :disabled="!orderMenuCampaign.orderMenuIsRequiredGps"
            />
          </div>
        </div>

        <LoungeZoneComponent
          :key="refreshMapKey"
          :disabled="!orderMenuCampaign.orderMenuIsRequiredGps"
          @position-selected="updatePosition"
          :radius="orderMenuCampaign.orderMenuRadius"
          :longitude="orderMenuCampaign.orderMenuLongitude"
          :latitude="orderMenuCampaign.orderMenuLatitude"
        />
      </div>



    </div>

  </div>

</template>


<style scoped>
.opacity-50 {
  opacity: 0.5;
}

.pointer-events-none {
  pointer-events: none;
}
</style>